import DefaultLayout from './default'
import NonAuthLayoutL from './no-side-bar'
import EmptyLayout from './empty'

export default {
  default: DefaultLayout,
  empty: EmptyLayout,
  'no-side-bar': NonAuthLayoutL,
}
